



















import { Component, Vue, Watch, Prop } from "vue-property-decorator";

@Component({ name: "ui-table" })
export default class UiTableComponent extends Vue {
  @Prop({ type: Array })                          Items: Object[];
  @Prop({ default: 2, type: Number })         columnGap: number;
  @Prop({ default: 2, type: Number })            rowGap: number;
  @Prop({ default: "", type: String })  templateColumns: string;
  @Prop({type:Number, default:0})            selectLine: number
  @Prop({ default: true })                        light: boolean;
  @Prop({ default: false })                        dark: boolean;
  @Prop({ default: false })                        w100: boolean;

  selLine=this.selectLine

  styleObject = {
    "grid-column-gap": this.columnGap + "px",
    "grid-row-gap": this.rowGap + "px",
    "grid-template-columns": this.templateColumns
  };

 

  @Watch("templateColumns") 
  onCangeTemplateColumns(){
     this.styleObject = null;
     this.styleObject = {
    "grid-column-gap": this.columnGap + "px",
    "grid-row-gap": this.rowGap + "px",
    "grid-template-columns": this.templateColumns,
   };
  }
  getInnerTableStyle(idRow: number) {
     let styleInnerObject = {
      "grid-row-start": idRow + 2,
      "grid-row-end": idRow + 2,
      "grid-column-start": 1,
      "grid-column-end": this.templateColumns.split(' ').length + 1
     }
     return styleInnerObject;
  }


  changeCol(v1:any,v2:any){
    this.selLine=v1
    //console.log("table", v1)
  }
  mounted() {
    // console.table(this.styleObject)
  }
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./~/ui-table/src/ui-table.vue